<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="titles">
            <el-form :inline="true" class="form-inlines u-f u-jsb">
                <div>
                    <el-form-item label="时间:">
                        <el-date-picker v-model="timeValue" type="monthrange" size="small" value-format="yyyy-MM"
                            range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="search">搜索</el-button>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item>
                        <el-button size="small" icon="el-icon-circle-plus-outline" @click="add" type="primary">新增
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border style="width: 100%" v-loading="loadings" :height="height"
                ref="configurationTable">
                <el-table-column prop="date" label="日期" show-overflow-tooltip></el-table-column>
                <el-table-column prop="tgfy" label="推广费用" show-overflow-tooltip></el-table-column>
                <el-table-column prop="gzl" label="关注量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="gzcb" label="关注成本" show-overflow-tooltip></el-table-column>
                <el-table-column prop="zclv" label="注册率" show-overflow-tooltip></el-table-column>
                <el-table-column prop="zcl" label="注册量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="zccb" label="注册成本" show-overflow-tooltip></el-table-column>
                <el-table-column prop="xfrc" label="消费人次" show-overflow-tooltip></el-table-column>
                <el-table-column prop="ptxf" label="平台总消费" show-overflow-tooltip></el-table-column>
                <el-table-column prop="kj" label="客均" show-overflow-tooltip></el-table-column>
                <el-table-column prop="create_time" label="创建时间" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row)" type="primary" size="mini">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog title="新增" :visible.sync="dialogVisible" top='20px'>
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-row :gutter="5">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-form-item label="时间:" prop="date" class="m-b">
                                <el-date-picker v-model="ruleForm.date" type="month" placeholder="选择时间"
                                    value-format="yyyy-MM" size="small">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="推广费用" prop="tgfy">
                                <el-input v-model="ruleForm.tgfy" style="max-width: 320px" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="关注量" prop="gzl">
                                <el-input v-model="ruleForm.gzl" style="max-width: 320px" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="关注成本" prop="gzcb">
                                <el-input v-model="ruleForm.gzcb" style="max-width: 320px" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="注册率" prop="zclv">
                                <el-input v-model="ruleForm.zclv" style="max-width: 320px" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="注册量" prop="zcl">
                                <el-input v-model="ruleForm.zcl" style="max-width: 320px" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="注册成本" prop="zccb">
                                <el-input v-model="ruleForm.zccb" style="max-width: 320px" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="平台消费人次" prop="xfrc">
                                <el-input v-model="ruleForm.xfrc" style="max-width: 320px" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="平台总消费" prop="ptxf">
                                <el-input v-model="ruleForm.ptxf" style="max-width: 320px" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="客均" prop="kj">
                                <el-input v-model="ruleForm.kj" style="max-width: 320px" size="small"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size='small'>取 消</el-button>
                <el-button @click="subForm('ruleForm')" size='small' type="primary">提交</el-button>
            </span>
        </el-dialog>


        <el-dialog title="修改" :visible.sync="dialogVisibled" top='20px'>
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForms" :rules="rulesd" ref="ruleForms" label-width="100px" class="demo-ruleForm">
                    <el-row :gutter="5">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-form-item label="时间:" prop="date" class="m-b">
                                <el-date-picker v-model="ruleForms.date" type="month" placeholder="选择时间"
                                    value-format="yyyy-MM" size="small">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="推广费用" prop="tgfy">
                                <el-input v-model="ruleForms.tgfy" style="max-width: 320px" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="关注量" prop="gzl">
                                <el-input v-model="ruleForms.gzl" style="max-width: 320px" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="关注成本" prop="gzcb">
                                <el-input v-model="ruleForms.gzcb" style="max-width: 320px" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="注册率" prop="zclv">
                                <el-input v-model="ruleForms.zclv" style="max-width: 320px" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="注册量" prop="zcl">
                                <el-input v-model="ruleForms.zcl" style="max-width: 320px" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="注册成本" prop="zccb">
                                <el-input v-model="ruleForms.zccb" style="max-width: 320px" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="平台消费人次" prop="xfrc">
                                <el-input v-model="ruleForms.xfrc" style="max-width: 320px" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="平台总消费" prop="ptxf">
                                <el-input v-model="ruleForms.ptxf" style="max-width: 320px" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="客均" prop="kj">
                                <el-input v-model="ruleForms.kj" style="max-width: 320px" size="small"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibled = false" size='small'>取 消</el-button>
                <el-button @click="EditForm('ruleForms')" size='small' type="primary">提交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                loadings: false,
                timeValue: [],
                tableData: [],
                dialogVisible: false,
                ruleForm: {
                    date: '',
                    tgfy: '',
                    gzl: "",
                    gzcb: "",
                    zclv: "",
                    zcl: "",
                    zccb: "",
                    xfrc: "",
                    ptxf: "",
                    kj: "",
                },
                rules: {
                    date: [{
                        required: true,
                        message: '请选择日期',
                        trigger: 'blur'
                    }],
                    tgfy: [{
                        required: true,
                        message: '请填写推广费用',
                        trigger: 'blur'
                    }],
                },
                dialogVisibled: false,
                ruleForms: {
                    date: '',
                    tgfy: '',
                    gzl: "",
                    gzcb: "",
                    zclv: "",
                    zcl: "",
                    zccb: "",
                    xfrc: "",
                    ptxf: "",
                    kj: "",
                },
                rulesd: {
                    date: [{
                        required: true,
                        message: '请选择日期',
                        trigger: 'blur'
                    }],
                    tgfy: [{
                        required: true,
                        message: '请填写推广费用',
                        trigger: 'blur'
                    }],
                },
                eid: '',
                height: null,
            }
        },
        mounted() {
            let that = this;
            var titles = that.$refs.titles.offsetHeight
            that.height = window.innerHeight - titles - 150 + 'px'
            window.onresize = () => {
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 150 + 'px'
            }
            that.begin()
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        methods: {
            begin() {
                let that = this
                that.gettime()
                that.search()
            },
            gettime() {
                let that = this;
                let nowDate = new Date(new Date().getTime())
                let year = nowDate.getFullYear();
                let month = nowDate.getMonth() + 1;
                let day = nowDate.getDate();
                month = month > 9 ? month : '0' + month
                //day = day > 9 ? day : '0' + day
                that.timeValue = [
                    year + "-" + month,
                    year + "-" + month
                ];
            },
            //查询
            search() {
                let that = this

                if (!this.timeValue) {
                    this.$message({
                        showClose: true,
                        message: '请选择时间段',
                        type: 'error'
                    });
                    return
                }
                that.loadings = true
                that.tableData = [];
                axios.defaults.headers.common["token"] = this.user.token;
                axios.post("/admin/getGzhFeeZbsz", {
                        date1: that.timeValue[0],
                        date2: that.timeValue[1],
                    })
                    .then(response => {
                        that.loadings = false
                        that.tableData = response.data.data
                        this.$refs.configurationTable.$el.style.width = '99.99%'
                    })
                    .catch(error => {})
            },
            //添加
            add() {
                let that = this
                that.dialogVisible = true
                that.ruleForm = {
                    date: '',
                    tgfy: '',
                    gzl: "",
                    gzcb: "",
                    zclv: "",
                    zcl: "",
                    zccb: "",
                    xfrc: "",
                    ptxf: "",
                    kj: "",
                }
            },
            //新增
            subForm(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        axios.defaults.headers.common["token"] = this.user.token;
                        axios.post("/admin/addGzhFeeZbsz", {
                                date: that.ruleForm.date,
                                tgfy: that.ruleForm.tgfy,
                                gzl: that.ruleForm.gzl,
                                gzcb: that.ruleForm.gzcb,
                                zclv: that.ruleForm.zclv,
                                zcl: that.ruleForm.zcl,
                                zccb: that.ruleForm.zccb,
                                xfrc: that.ruleForm.xfrc,
                                ptxf: that.ruleForm.ptxf,
                                kj: that.ruleForm.kj,
                                create_author: this.user.username,
                            })
                            .then(response => {
                                if (response.data.code == 200) {
                                    that.dialogVisible = false
                                    this.$message({
                                        showClose: true,
                                        type: 'success',
                                        message: response.data.msg
                                    });
                                    that.search()
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: response.data.msg,
                                        type: 'error'
                                    });
                                }
                            })
                            .catch(error => {})
                    } else {
                        that.$alert('信息遗漏未填')
                        return false;
                    }
                });
            },

            //编辑
            handleClick(row) {
                let that = this
                that.eid = row.id
                that.dialogVisibled = true
                that.ruleForms.date = row.date
                that.ruleForms.tgfy = row.tgfy
                that.ruleForms.gzl = row.gzl
                that.ruleForms.gzcb = row.gzcb
                that.ruleForms.zclv = row.zclv
                that.ruleForms.zcl = row.zcl
                that.ruleForms.zccb = row.zccb
                that.ruleForms.xfrc = row.xfrc
                that.ruleForms.ptxf = row.ptxf
                that.ruleForms.kj = row.kj
            },
            EditForm(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        axios.defaults.headers.common["token"] = this.user.token;
                        axios.post("/admin/editGzhFeeZbsz", {
                                id: that.eid,
                                date: that.ruleForms.date,
                                tgfy: that.ruleForms.tgfy,
                                gzl: that.ruleForms.gzl,
                                gzcb: that.ruleForms.gzcb,
                                zclv: that.ruleForms.zclv,
                                zcl: that.ruleForms.zcl,
                                zccb: that.ruleForms.zccb,
                                xfrc: that.ruleForms.xfrc,
                                ptxf: that.ruleForms.ptxf,
                                kj: that.ruleForms.kj,
                                update_author: this.user.username,
                            })
                            .then(response => {
                                if (response.data.code == 200) {
                                    that.dialogVisibled = false
                                    this.$message({
                                        showClose: true,
                                        type: 'success',
                                        message: response.data.msg
                                    });
                                    that.search()
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: response.data.msg,
                                        type: 'error'
                                    });
                                }
                            })
                            .catch(error => {})
                    } else {
                        that.$alert('信息遗漏未填')
                        return false;
                    }
                });
            }

        },
    }
</script>

<style lang="scss" scoped>

</style>